// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"01e0db54","598":"df1c93bd","703":"1725a2e6","787":"caacba8d"}[chunkId] + ".chunk.js";
};